export default {
  // 首页
  home: {
    title: 'GWOFY',
    subtitle: '跨境電商綜合服務商',
    hero: {
      eyebrow: 'GWOFY',
      title: '跨境電商綜合服務商',
      subtitle: '覆蓋跨境物流、國際貨代、海外倉儲、買家權益保障與 On-Chain Data 區塊鏈驗證，為賣家與合作機構提供一站式出海服務能力。',
      ctaGooval: '了解 Gooval',
      ctaContact: '聯絡我們',
      imageLabel: 'Hero image',
      imageKeyword: 'global logistics warehouse shipping containers aerial view modern'
    },
    services: {
      title: '我們的服務能力',
      subtitle: '從物流履約到貨代協同、海外倉儲與 On-Chain Data 區塊鏈驗證，為跨境賣家與合作夥伴提供可落地的綜合服務支持。',
      imageLabel: 'Service image',
      logistics: {
        title: '跨境物流',
        description: '覆蓋末端派送、時效線路與全程軌跡追蹤，幫助賣家提升履約效率與買家體驗。',
        keyword: 'cross border last mile delivery parcel tracking modern courier'
      },
      freight: {
        title: '貨代服務',
        description: '提供頭程運輸、清關協同與多渠道幹線銜接，降低跨境供應鏈協同成本。',
        keyword: 'freight forwarding cargo ship port containers customs clearance'
      },
      warehouse: {
        title: '倉儲服務',
        description: '支持海外倉備貨、出入庫管理與庫存協同，適配多平台、多站點運營需求。',
        keyword: 'fulfillment warehouse shelves inventory management'
      },
      blockchain: {
        title: 'On-Chain Data',
        description: '為跨境電商應收賬款與核心交易數據提供鏈上驗真，生成不可篡改的可信憑證。',
        keyword: 'blockchain data verification network nodes secure ledger technology'
      }
    },
    blockchain: {
      label: '主要產品',
      title: 'On-Chain Data — 區塊鏈驗證服務',
      subtitle: '為跨境電商應收賬款與核心交易數據提供鏈上驗真，提升透明度與機構信任度。',
      description: '商戶授權後，平台可將核心經營數據加密上鏈，合作機構可即時驗證數據真實性與完整性。',
      imageLabel: 'On-Chain Data product image',
      imageKeyword: 'blockchain data verification network nodes secure ledger technology',
      cta: '查看 On-Chain Data',
      features: {
        feature1: {
          title: '數據授權與上鏈',
          description: '商戶授權 API 同步核心數據，加密上鏈，確保真實且不可篡改。'
        },
        feature2: {
          title: '應收賬款驗真',
          description: '應收賬款鏈上驗證，生成可信憑證，降低信息不對稱。'
        },
        feature3: {
          title: '機構即時查驗',
          description: '合作機構可獨立驗證商戶數據，提升授信與風控效率。'
        },
        feature4: {
          title: '多鏈支持',
          description: '支持 Ethereum、Polygon、Solana、Avalanche 等公鏈生態。'
        }
      }
    },
    gooval: {
      label: '主要產品',
      title: 'Gooval — 物流服務與買家權益包',
      subtitle: '為獨立站與跨境商家提供運輸保障與售後權益能力，商家可零成本接入，買家可自選保障方案。',
      imageLabel: 'Gooval product image',
      imageKeyword: 'ecommerce checkout shipping protection shield package insurance UI mockup',
      shopify: 'Shopify 插件',
      openApi: 'Open API 文檔',
      features: {
        feature1: {
          title: '運輸保障',
          description: '覆蓋丟件、破損、被盜等常見物流風險，降低售後糾紛與客服壓力。'
        },
        feature2: {
          title: '買家權益包',
          description: '支持退換貨、延保等權益能力，提升轉化與復購體驗。'
        },
        feature3: {
          title: 'Shopify 一鍵接入',
          description: '通過 Shopify App 快速安裝，適配結賬頁與購物車場景。'
        },
        feature4: {
          title: 'Open API 對接',
          description: '支持自建站與其他系統對接，靈活集成到現有業務流程。'
        }
      }
    },
    insurance: {
      label: '主要產品',
      title: '吉物安途 - 亚马逊海外仓货损保障',
      subtitle: '面向跨境場景的保險合作方案，為物流與交易鏈路提供保險支持。',
      description: '具體保障範圍與條款以合作產品頁面為準，歡迎賣家與機構合作夥伴進一步了解。',
      imageLabel: 'Insurance product image',
      imageKeyword: 'business insurance partnership shield document professional office',
      cta: '了解合作產品',
      features: {
        feature1: '持牌保險合作背書，提升交易與履約信任度',
        feature2: '適配跨境物流與電商交易場景',
        feature3: '支持機構與賣家按需了解合作方案'
      }
    },
    financing: {
      label: '金融服務',
      title: '跨境電商應收賬款融資',
      subtitle: '面向跨境電商場景，提供應收賬款融資支持，幫助賣家優化資金周轉。',
      description: '我們持有香港放債人牌照，可為符合條件的跨境電商賣家提供應收賬款融資相關服務。具體融資條件、額度與審批要求以正式協議為準。',
      imageLabel: 'Financing service image',
      imageKeyword: 'cross border ecommerce accounts receivable financing cash flow business capital professional office blue teal',
      licenseLabel: '放債人牌照號碼',
      licenseNumber: '6675',
      warning: '忠告:借錢梗要還，咪俾錢中介',
      cta: '聯絡我們了解融資',
      features: {
        feature1: '針對跨境電商應收賬款場景設計',
        feature2: '持香港放債人牌照合規運營',
        feature3: '支持賣家就資金周轉需求進行諮詢對接'
      }
    },
    whyChoose: {
      title: '為什麼選擇 GWOFY',
      items: {
        item1: {
          title: '一站式服務',
          description: '物流、貨代、倉儲、On-Chain Data 與權益保障能力協同，減少多方對接成本。'
        },
        item2: {
          title: '產品化接入',
          description: 'Gooval 提供 Shopify 插件與 Open API，快速落地到業務場景。'
        },
        item3: {
          title: '保險合作背書',
          description: '與國泰保險合作，為跨境鏈路提供保險支持能力。'
        },
        item4: {
          title: '香港本地團隊',
          description: '熟悉跨境電商與國際協作，支持賣家與機構客戶溝通對接。'
        }
      }
    },
    banner: {
      mainTitle: '跨境電商應收賬款鏈上驗真解決方案',
      subtitle1: '以數據驗真提升透明度與信任度，',
      subtitle2: '為跨境商家與金融機構提供可信基礎設施',
      learnMore: '了解更多',
      contactUs: '聯絡我們'
    },
    vision: {
      mainTitle: '以真實貿易為錨，讓資金流動更透明、更可信',
      subtitle: '打造跨境電商應收賬款的鏈上數據標準，成為連接商戶與金融機構的數據基礎設施',
      button: '查看商家鏈上數據'
    },
    market: {
      mainTitle: '中國跨境電商年交易規模 > 5,000 億美元，但商家普遍面臨資金痛點：',
      subtitle: '**由於交易數據不透明、缺乏即時驗真，傳統金融機構難以及時提供支持',
      features: {
        feature1: {
          title: '⏳回款慢',
          description: '60–90天，資金長期佔壓'
        },
        feature2: {
          title: '💸現金緊',
          description: '30% 商家利潤率不足 10%，「有訂單、沒現金」'
        },
        feature3: {
          title: '🚫增長受阻',
          description: '周轉率僅 4 次/年，難以支撐高增長'
        },
        feature4: {
          title: '⚠️風險高',
          description: '旺季備貨與倉儲疊加，資金鏈隨時斷裂'
        }
      }
    },
    dataBridge: {
      mainTitle: 'Gwofy, 商家與機構之間的數據橋梁',
      mainTitleEn: 'Our Solution: A Data Bridge',
      features: {
        feature1: {
          title: '數據授權與上鏈驗真',
          description: '商戶授權 API，同步核心數據，加密上鏈，真實且不可篡改',
        },
        feature2: {
          title: '透明度提升',
          description: '應收賬款鏈上驗證，生成可信憑證，降低信息不對稱',
        },
        feature3: {
          title: '技術優勢',
          description: 'Hash 驗真｜實時更新｜隱私保護',
        }
      }
    },
    onChainData: {
      title: 'Gwofy <strong>定時打包商戶數據並上鏈存證</strong>，確保資料真實且不可篡改<br/>合作機構可即時驗證商戶應收賬款數據，全面提升<strong>透明度與信任度</strong>',
      button: '查看商家鏈上數據'
    },
    merchantOnboarding: {
      title: '商戶接入流程',
      step1: {
        title: '商戶申請',
        description: '提交申請資料'
      },
      step2: {
        title: '上線審核',
        description: '篩選經營穩定商戶'
      },
      step3: {
        title: '數據授權',
        description: 'API 實時同步數據'
      },
      step4: {
        title: '上鏈存真',
        description: '每小時數據匯總上鏈'
      }
    },
    safeguards: {
      mainTitle: '平台保障機制',
      features: {
        feature1: {
          title: '動態監測',
          description: '每日更新商戶數據與授信條件'
        },
        feature2: {
          title: '異常識別',
          description: '高退貨、費用異常、店鋪風險鏈上標記'
        },
        feature3: {
          title: '合規保障',
          description: 'KYC / AML / GDPR/ 香港私隱條例'
        }
      }
    },
    partnerships: {
      mainTitle: '合作與展望',
      payments: {
        title: '支付與清算合作：',
        description: '銀行、支付公司'
      },
      data: {
        title: '數據合作：',
        description: '拓展 Amazon → Shopify、eBay，多全球電商平台'
      },
      financial: {
        title: '金融合作：',
        description: '為銀行與資產管理方提供鏈上數據驗真'
      }
    },
    founder: {
      title: '創始人/CEO'
    },
    contact: {
      title: '聯絡我們',
      name: '姓名:',
      email: '郵箱:',
      companyName: '公司名稱:',
      comment: '留言:',
      submit: '立即聯絡',
      nameRequired: '姓名為必填項',
      emailRequired: '郵箱為必填項',
      emailInvalid: '請輸入有效的郵箱地址',
      companyNameRequired: '公司名稱為必填項',
      commentRequired: '留言為必填項',
      submitSuccess: '表單提交成功！',
      networkError: '網絡異常，請稍後再試',
      submitting: '提交中...'
    }
  },

  // RWA页面
  rwa: {
    title: '資產通證明細',
    backToList: '返回資產列表',
    tableHeaders: {
      storeId: '店鋪ID',
      orderId: '訂單ID',
      amount: '金額',
      signTime: '簽收時間',
      expectedPaymentTime: '預計打款時間',
      token: 'Token ID',
      time: '時間',
      assetProof: '資產證明'
    },
    stats: {
      tokenScale: '通證規模',
      totalStakeScale: '總質押規模',
      coinsDistribution: 'Coins分配總額'
    },
    listTitle: '資產通證列表',
    datePicker: {
      selectDate: '選擇日期：',
      startDate: '開始日期',
      endDate: '結束日期',
      to: '至',
      confirm: '確定',
      cancel: '取消',
      selectStartDate: '選擇開始日期',
      selectEndDate: '選擇結束日期'
    },
    errors: {
      loadFailed: '數據加載失敗',
      retry: '重新加載',
      noData: '暫無數據'
    }
  },

  // HomeLayout
  homeLayout: {
    header: {
      products: '主要產品',
      gooval: 'Gooval',
      insurance: '保險合作',
      blockchain: 'On-Chain Data',
      openMenu: '打開產品選單',
      closeMenu: '關閉產品選單'
    },
    footer: {
      subtitle: '跨境電商綜合服務商',
      products: '相關產品',
      about: '關於我們',
      whitepaper: '白皮書',
      copyright: 'Copyright©2025 GWOFY',
      contactInfo: '联系方式',
      email: '郵箱:',
      address: '公司地址: 香港上環文鹹西街71號成利源大廈12樓',
      aboutUs: '關於我們',
      whitePaper: '白皮書',
      termsOfUse: '使用條款',
      complianceDisclaimer: '合規與安全',
      disclaimer1: 'Gwofy 提供跨境電商綜合服務相關資訊，包括物流、貨代、倉儲、Gooval、保險合作、On-Chain Data 區塊鏈驗證，以及 <strong>跨境電商應收賬款融資</strong> 服務。本網站內容不構成任何證券、代幣或其他受監管產品的要約、招攬或投資建議',
      disclaimer2: '本平台服務主要面向 <strong>跨境電商賣家、供應鏈合作方及合格機構合作夥伴</strong>。部分產品可能僅限專業投資者或符合資格之對象；零售投資者及特定司法轄區居民——包括香港(非專業投資者)、中國內地、美國、加拿大、印度、韓國及其他法律禁止參與的地區——不得使用受限產品',
      disclaimer3: '使用服務具有風險，相關用戶或合作方可能須完成 <strong>KYC/AML 審核</strong>，並自行確保遵守所在司法轄區的法律法規',
      license: '放債人牌照號碼：<strong>6675</strong>',
      warning: '忠告:借錢梗要還，咪俾錢中介'
    }
  },

  // 使用條款页面
  termsOfUse: {
    title: '使用條款',
    effectiveDate: '生效日期：2026.07.16',
    welcome: '歡迎訪問 Gwofy（以下簡稱「本平台」或「我們」）。本平台由 GWOFY HK LIMITED 運營，提供跨境電商綜合服務相關資訊，包括跨境物流、國際貨代、海外倉儲，以及 Gooval 物流與買家權益產品、保險合作產品，與 On-Chain Data 區塊鏈驗證服務之介紹與接入指引。使用本網站即表示您同意以下條款。',
    sections: {
      scope: {
        title: '1. 適用範圍',
        content: '本條款適用於所有訪問本網站、查閱本平台資訊，或透過本平台了解、申請、接入相關服務與合作產品之個人或機構。若您不同意本條款，請立即停止使用本網站。'
      },
      noOffer: {
        title: '2. 服務說明與非投資聲明',
        points: [
          '本網站所載內容僅供一般資訊與業務介紹用途，<strong>不構成任何證券、代幣、保險合約或其他受監管金融產品之要約、招攬或投資建議</strong>。',
          '本平台提供或介紹的物流、貨代、倉儲、Gooval、保險合作產品及 On-Chain Data 區塊鏈驗證服務，其具體服務範圍、費率、保障條款與接入條件，均以雙方正式簽署之協議、合作方官方頁面或產品條款為準。',
          '本平台不提供法律、財務、稅務或投資意見。您應在作出商業決策前，自行尋求專業顧問之獨立建議。'
        ]
      },
      investorEligibility: {
        title: '3. 服務適用對象',
        content1: '本平台服務主要面向 <strong>跨境電商賣家、物流與供應鏈合作方、保險及金融合作機構</strong> 等商業主體。',
        content2: '部分合作產品（尤其保險或機構數據驗真相關服務）可能僅向符合資格之機構、專業投資者或特定司法轄區內允許之對象提供。下列地區之居民或使用者，若當地法律禁止參與，不得使用相關產品或服務，包括但不限於：',
        prohibitedJurisdictions: [
          '香港（非專業投資者，如產品僅限專業投資者）',
          '中國內地（如當地法律限制相關服務）',
          '美國、加拿大、印度、韓國',
          '其他當地法律禁止提供或使用類似服務之地區'
        ],
        verification: '涉及商戶接入、保險合作、On-Chain Data 數據授權、資金或合規相關服務時，用戶或合作方可能須完成 <strong>KYC/AML</strong> 或其他合規審核程序。'
      },
      userResponsibilities: {
        title: '4. 用戶責任',
        content: '您同意：',
        responsibilities: [
          '提供真實、準確、完整的商業與聯絡資訊，並及時更新',
          '不以任何非法方式使用本網站、Gooval 插件、Open API、On-Chain Data 或第三方合作產品',
          '不嘗試繞過平台安全、合規、審核或資料保護措施',
          '對因使用本網站資訊、接入第三方產品或自行商業決策所產生之後果自行承擔責任'
        ]
      },
      riskDisclaimer: {
        title: '5. 風險提示',
        risks: [
          '跨境物流、貨代、倉儲及電商履約服務可能受到 <strong>運輸延誤、清關政策、庫存波動、合作方營運及監管變化</strong> 等影響。',
          'Gooval 及保險合作產品之保障範圍、理賠條件與收益安排，均以各產品官方條款為準；本平台不保證任何特定商業結果或收益。',
          'On-Chain Data 區塊鏈驗證服務依賴商戶授權、資料同步、加密與鏈上記錄；可能存在 <strong>資料延遲、節點或網絡波動、授權範圍限制及第三方查驗結果差異</strong> 等風險。本平台不構成任何融資、授信或投資承諾。',
          '您可能因市場變化、服務中斷、資料延遲或第三方原因遭受商業損失。本平台對因使用本網站資訊或第三方產品而產生之直接或間接損失，在法律允許範圍內不承擔責任。'
        ]
      },
      intellectualProperty: {
        title: '6. 知識產權',
        content: '本網站上的內容（包括但不限於文字、圖像、標誌、產品介紹、介面設計）受版權及其他知識產權法保護。未經授權，您不得複製、分發、修改或作商業使用。Gooval、On-Chain Data 及合作方產品之商標、名稱與相關權利歸各自權利人所有。'
      },
      amendments: {
        title: '7. 條款修改',
        content: '我們保留隨時修改或更新本條款之權利。最新版本將發佈於本網站，您繼續使用本網站即視為接受更新後之條款。'
      },
      governingLaw: {
        title: '8. 適用法律',
        content: '本條款受 <strong>香港特別行政區法律</strong> 管轄並依其解釋。任何爭議均提交香港法院專屬管轄。'
      }
    },
    declaration: '<strong>聲明：</strong>使用本網站即表示您已閱讀、理解並同意本條款。'
  },

  // 合規聲明页面
  complianceDisclaimer: {
    title: '合規與安全',
    sections: {
      informationPurpose: {
        title: '1. 資訊用途',
        content: '本網站所提供之所有內容，包括公司介紹、服務說明、產品展示、合作連結及文件（以下統稱「資訊」），僅供一般參考與業務溝通之用。上述資訊並不構成，且不應被解釋為：',
        points: [
          '任何金融工具、證券、代幣、保險合約或其他受監管產品之出售要約、購買邀約或投資建議',
          '任何形式的法律、財務、稅務、保險或投資意見',
          '在任何司法轄區內進行交易之誘因或邀請，若該等要約或邀請在當地屬於非法'
        ]
      },
      noInvestmentOffer: {
        title: '2. 服務與產品免責',
        content: '本網站介紹之跨境物流、貨代、倉儲、Gooval 物流與買家權益產品、保險合作產品，以及 On-Chain Data 區塊鏈驗證服務，其具體服務內容、收費、保障範圍、理賠規則、數據授權與技術接入條件，均以正式協議、合作方產品頁面、App Store 條款或官方文件為準。本平台對第三方產品頁面內容之準確性、完整性及持續可用性不作保證。'
      },
      investorEligibility: {
        title: '3. 適用對象與資格要求',
        content1: '本平台服務主要面向跨境電商賣家、物流與供應鏈合作方，以及符合條件之機構合作夥伴。部分產品或合作方案可能僅限於符合適用法律規定之 <strong>合格機構、專業投資者或商業客戶</strong>，例如：',
        examples: [
          '<strong>香港</strong>：保險或金融相關產品可能僅適用《證券及期貨條例》（第571章）所定義之「專業投資者」或相關合規客戶',
          '<strong>新加坡</strong>：部分機構服務可能僅適用《證券及期貨法》所定義之「認可投資者」',
          '<strong>歐盟</strong>：部分機構服務可能僅適用 MiFID II 所定義之「專業客戶」'
        ],
        content2: '涉及商戶接入、保險合作、On-Chain Data 數據授權、資金託管或高風險服務時，相關方須完成本平台或合作方要求之 <strong>了解您的客戶（KYC）</strong> 及 <strong>反洗錢（AML）</strong> 等合規程序。'
      },
      geographicRestrictions: {
        title: '4. 地域限制',
        content: '部分合作產品或服務可能不向下列司法轄區之居民或使用者提供，包括但不限於：',
        restrictions: [
          '香港特別行政區之零售及非專業投資者（如產品僅限專業投資者）',
          '中華人民共和國境內居民（不含香港、澳門及台灣），如當地法律另有限制',
          '美國、加拿大、印度、韓國',
          '以及其他當地法律禁止提供或使用類似產品或服務之地區'
        ],
        warning: '任何個人或機構若違反適用法律或產品資格要求而接入或使用相關服務，該等行為可能導致服務終止，並由使用者自行承擔法律責任。'
      },
      riskDisclosure: {
        title: '5. 風險提示與免責聲明',
        content: '跨境電商綜合服務涉及物流履約、清關協同、倉儲管理、買家權益保障、保險合作及 On-Chain Data 區塊鏈驗證等多個環節，可能存在 <strong>運輸延誤、貨損、政策變化、系統中斷、資料延遲、鏈上記錄波動、合作方履約及監管風險</strong>。本平台不保證任何服務之持續不中斷、商業收益、授信結果或理賠結果，亦不對第三方合作產品頁面、API、插件或外部連結內容承擔責任。'
      },
      rightsReservation: {
        title: '6. 權利保留',
        content: '本平台保留以下權利，且可自行全權決定：',
        rights: [
          '拒絕未達到資格、合規或商業審核要求之個人或機構使用相關服務',
          '修改、暫停或終止任何服務介紹、合作連結或產品接入說明',
          '根據法律、監管、合作方要求或業務需要，更新本合規聲明及網站內容'
        ]
      },
      governingLaw: {
        title: '7. 適用法律',
        content: '本合規聲明受 <strong>香港特別行政區法律</strong> 管轄並依其解釋。'
      }
    },
    declaration: '<strong>提示：</strong>訪問或使用本網站，即表示您已閱讀、理解並同意遵守本合規與安全聲明。'
  },

  // 白皮书页面
  whitePaper: {
    title: 'Gwofy：跨境電商綜合服務商',
    version: '版本: v2.1',
    sections: {
      vision: {
        title: '1. 公司願景與定位',
        content1: 'Gwofy 是一家面向跨境電商生態的 <strong>綜合服務商</strong>，致力於為賣家與合作機構提供跨境物流、國際貨代、海外倉儲、買家權益保障及區塊鏈驗證等一站式能力。',
        content2: '我們透過 <strong>Gooval</strong>、<strong>保險合作方案</strong> 與 <strong>On-Chain Data</strong>，幫助商家提升履約體驗、降低售後糾紛，並為跨境交易與應收賬款數據提供更高透明度與信任基礎。',
        disclaimer: '本文件僅為業務介紹，不構成投資要約、保險要約或融資邀請。具體產品條款以正式協議及合作方官方文件為準。'
      },
      marketBackground: {
        title: '2. 市場背景',
        content1: '隨著獨立站、Shopify 及多平台跨境電商快速發展，賣家在出海過程中普遍面臨以下挑戰：',
        painPoints: [
          '<strong>物流履約複雜：</strong>跨境運輸、末端派送與軌跡追蹤難以統一管理',
          '<strong>供應鏈協同成本高：</strong>頭程運輸、清關與幹線銜接需要專業貨代支持',
          '<strong>海外倉儲壓力大：</strong>旺季備貨、庫存周轉與多倉協同考驗運營能力',
          '<strong>售後與風險成本高：</strong>丟件、破損、退換貨及保障缺失影響轉化與品牌信任',
          '<strong>數據信任不足：</strong>跨境應收賬款與核心經營數據缺乏即時、可驗證憑證，影響機構合作效率'
        ],
        content2: '賣家與合作機構需要的不僅是單點服務，而是能夠覆蓋 <strong>物流、倉儲、權益保障、保險合作與鏈上驗真</strong> 的綜合服務能力，以支持穩定出海與規模化增長。'
      },
      coreServices: {
        title: '3. 核心服務能力',
        content: 'Gwofy 圍繞跨境電商交易與履約鏈路，提供以下綜合服務：',
        logistics: {
          title: '3.1 跨境物流',
          contents: [
            '覆蓋末端派送、時效線路與全程軌跡追蹤',
            '適配獨立站、Shopify 及多平台賣家履約需求',
            '幫助商家提升配送透明度與買家體驗'
          ]
        },
        freight: {
          title: '3.2 貨代服務',
          contents: [
            '提供頭程運輸、清關協同與多渠道幹線銜接',
            '協助賣家降低跨境供應鏈協同成本',
            '支持不同目的地與運輸方式之業務組合'
          ]
        },
        warehouse: {
          title: '3.3 倉儲服務',
          contents: [
            '支持海外倉備貨、出入庫管理與庫存協同',
            '適配旺季備貨與多站點運營場景',
            '提升庫存可視化與履約效率'
          ]
        }
      },
      gooval: {
        title: '4. Gooval 產品',
        content: 'Gooval 是 Gwofy 推出的 <strong>物流服務與買家權益包</strong> 產品，面向跨境與獨立站商家，提供運輸保障與售後權益能力。',
        features: {
          title: '4.1 核心能力',
          points: [
            '<strong>運輸保障：</strong>覆蓋丟件、破損、被盜等常見物流風險',
            '<strong>買家權益包：</strong>支持退換貨、延保等權益能力，改善購物體驗',
            '<strong>商家友好：</strong>支持買家自選保障方案，降低商家接入與客服成本'
          ]
        },
        integration: {
          title: '4.2 接入方式',
          contents: [
            '<strong>Shopify 插件：</strong>可透過 Shopify App Store 安裝 <a href="https://apps.shopify.com/gooval-shipping-protection" target="_blank">Gooval Shipping Protection</a>',
            '<strong>Open API：</strong>支持自建站與其他系統透過 API 對接，詳見 <a href="https://www.gooval.io/docs/open-api#overview" target="_blank">Open API 文檔</a>',
            '適用於希望快速上線運輸保障與買家權益能力的 DTC 與跨境商家'
          ]
        }
      },
      insurance: {
        title: '5. 保險合作產品',
        content: 'Gwofy 與国泰保险等合作方共同推出面向跨境場景的保險合作方案，為物流與交易鏈路提供保險支持。',
        contents: [
          '面向跨境物流、電商交易等場景提供保險合作能力',
          '提升交易與履約過程中的信任與風險管理能力',
          '合作產品詳情請參閱官方頁面：<a href="https://jw.hedejj.com/" target="_blank">https://jw.hedejj.com/</a>'
        ],
        note: '保險產品之保障範圍、理賠條件、費率及適用對象，均以合作方官方條款與監管要求為準。'
      },
      onChainData: {
        title: '6. On-Chain Data 區塊鏈驗證服務',
        content: 'On-Chain Data 是 Gwofy 提供的 <strong>區塊鏈驗證服務</strong>，為跨境電商應收賬款與核心交易數據提供鏈上驗真，生成不可篡改的可信憑證，提升機構合作透明度與信任度。',
        features: {
          title: '6.1 核心能力',
          points: [
            '<strong>數據授權與上鏈：</strong>商戶授權後，可透過 API 同步核心經營數據，加密上鏈，確保真實且不可篡改',
            '<strong>應收賬款驗真：</strong>對應收賬款進行鏈上驗證，生成可信憑證，降低信息不對稱',
            '<strong>機構即時查驗：</strong>合作機構可獨立驗證商戶數據，提升授信與風控效率',
            '<strong>多鏈支持：</strong>支持 Ethereum、Polygon、Solana、Avalanche 等公鏈生態'
          ]
        },
        access: {
          title: '6.2 查驗與接入',
          contents: [
            '商戶與合作機構可透過平台 <a href="/on-chain-data">On-Chain Data</a> 頁面查閱鏈上數據與驗真結果',
            '服務範圍、數據授權條件、更新頻率與查驗權限，均以正式協議及平台說明為準',
            'On-Chain Data 僅提供數據驗真與透明度能力，<strong>不構成融資、授信、投資或其他金融產品要約</strong>'
          ]
        }
      },
      compliance: {
        title: '7. 合規與資料安全',
        dataPrivacy: {
          title: '7.1 資料與隱私',
          contents: [
            '遵循適用之資料保護與隱私合規要求，包括 GDPR 及香港《個人資料（私隱）條例》',
            '在商戶授權範圍內處理業務、服務及鏈上驗真所需資料',
            '對敏感資料採取合理之安全保護措施，並按授權範圍進行加密與上鏈處理'
          ]
        },
        partnerCompliance: {
          title: '7.2 合作與合規',
          contents: [
            '涉及商戶接入、保險合作、On-Chain Data 數據授權或高風險服務時，將依要求完成 KYC/AML 等合規審核',
            '第三方產品與服務遵循各自合作方之監管與產品規則',
            '本平台持續優化服務流程，確保在合法合規框架內運營'
          ]
        }
      },
      cooperationEcosystem: {
        title: '8. 合作生態與展望',
        contents: [
          '<strong>電商平台合作：</strong>支持 Shopify 等平台的插件與 API 接入',
          '<strong>物流與倉儲合作：</strong>拓展跨境幹線、海外倉與履約網絡',
          '<strong>保險與金融合作：</strong>與国泰保险等機構合作，完善跨境保障能力',
          '<strong>數據與機構合作：</strong>透過 On-Chain Data 為合格機構提供可驗證之經營與應收賬款數據支持'
        ],
        note: 'Gwofy 將持續完善跨境電商綜合服務能力，為賣家與合作機構提供更穩定、更可擴展的出海基礎設施。'
      },
      futureVision: {
        title: '9. 使命與願景',
        contents: [
          '<strong>使命：</strong>以專業服務連接跨境電商賣家、物流網絡、保障體系與可信數據，讓出海更穩、更可信',
          '<strong>願景：</strong>成為跨境電商領域值得信賴的綜合服務商與產品化能力提供者'
        ]
      },
      legalDisclaimer: {
        title: '10. 合規聲明與限制',
        contents: [
          '本文件僅為業務介紹，不構成任何投資、保險或融資要約',
          'Gooval、保險合作、On-Chain Data 及其他產品之具體條款，以正式協議及合作方官方文件為準',
          '部分產品或服務可能不向以下地區之不符合資格對象提供：'
        ],
        restrictions: [
          '香港特別行政區的零售與非專業投資者（如產品僅限專業投資者）',
          '中華人民共和國（不含香港、澳門及臺灣），如當地法律另有禁止',
          '美國、加拿大、印度、韓國，以及其他當地法律禁止的地區'
        ]
      },
      contact: {
        title: '11. 聯絡方式',
        info: [
          '官方網站: <a href="https://hk.gwofy.com/" target="_blank">https://hk.gwofy.com/</a>',
          '聯絡郵箱: <a href="mailto:contact@gwofy.com" target="_blank">contact@gwofy.com</a>',
          '公司地址: 香港上環文咸西街71號成利源大廈12樓'
        ]
      }
    }
  }
} 